/* eslint-disable */
import { Container, Paper, Text } from '@mantine/core'
import useTranslation from 'next-translate/useTranslation'

const SubscriptionTab = () => {
  const { lang } = useTranslation('client')

  return (
    <Container size="sm">
      <Paper>
        {lang === 'en' ? (
          <>
            <div style={{ marginBottom: 30 }}>
              <Text size="xl" weight={700} style={{ marginBottom: 20 }}>
                Subscription and Payment Policy
              </Text>
              <Text size="lg">
                <span className="font-bold"> 9.1 Advance Payment:</span>{' '}
                Trainees must pay in advance using the electronic payment method
                provided on the center’s website.
                <br />
                <span className="font-bold">
                  {' '}
                  9.2 Accuracy of Information:
                </span>{' '}
                Trainees must ensure that all information provided during
                registration is true and accurate.
                <br />
                <span className="font-bold">
                  {' '}
                  9.3 Responsibility for Incorrect Information:
                </span>{' '}
                The center is not responsible for failure to implement requests
                due to incorrect information provided by trainees.
                <br />
                <span className="font-bold"> 9.4 VAT:</span> All fees are
                subject to a 15% VAT.
              </Text>
            </div>

            <div style={{ marginBottom: 30 }}>
              <Text size="xl" weight={700} style={{ marginBottom: 20 }}>
                Cancellation and Withdrawal Policy
              </Text>
              <Text size="lg">
                <span className="font-bold">
                  10.1 Refunds for Canceled Programs:
                </span>{' '}
                If the program is canceled by the center or seats are
                unavailable, the amount paid will be refunded to the customer.
                <br />
                <span className="font-bold">
                  {' '}
                  10.2 Confirmation of Registration:
                </span>{' '}
                Registration for any course or program is confirmed after
                approval by the center and availability of seats.
                <br />
                <span className="font-bold"> 10.3 Refund Conditions:</span> In
                the case of a refund, 25% will be deducted from the amount paid
                for value-added tax and electronic payment. This condition is
                applicable if the refund request is made before the date of the
                training activity. No amounts will be refunded after the date of
                the training activity. The amount can be transferred to the
                trainee’s internal wallet if they so desire.
                <br />
                <span className="font-bold"> Deduction for Refunds:</span> In
                case of a refund, 25% of the amount paid will be deducted for
                VAT and electronic payment.
              </Text>
            </div>

            <div style={{ marginBottom: 30 }}>
              <Text size="xl" weight={700} style={{ marginBottom: 20 }}>
                Contact Information
              </Text>
              <Text size="lg">
                For inquiries or assistance, please contact us through the
                Contact Us form on our website. We welcome your questions,
                concerns, and comments about our services.
              </Text>
            </div>
          </>
        ) : (
          <>
            <div style={{ marginBottom: 30 }}>
              <Text size="xl" weight={700} style={{ marginBottom: 20 }}>
                سياسة الاشتراك والدفع
              </Text>
              <Text size="lg">
                <span className="font-bold"> 9.1 الدفع المسبق:</span> يجب على
                المتدربين الدفع مسبقًا باستخدام طريقة الدفع الإلكترونية المتاحة
                على موقع السنتر.
                <br />
                <span className="font-bold"> 9.2 دقة المعلومات:</span> يجب على
                المتدربين التأكد من أن جميع المعلومات المقدمة أثناء التسجيل
                صحيحة ودقيقة.
                <br />
                <span className="font-bold">
                  {' '}
                  9.3 المسؤولية عن المعلومات الغير صحيحة:
                </span>{' '}
                لا يتحمل السنتر مسؤولية عدم تنفيذ الطلبات بسبب المعلومات الغير
                صحيحة التي قدمها المتدربون.
                <br />
                <span className="font-bold">
                  {' '}
                  9.4 ضريبة القيمة المضافة:
                </span>{' '}
                جميع الرسوم خاضعة لضريبة القيمة المضافة بنسبة 15٪.
              </Text>
            </div>

            <div style={{ marginBottom: 30 }}>
              <Text size="xl" weight={700} style={{ marginBottom: 20 }}>
                سياسة الإلغاء والانسحاب
              </Text>
              <Text size="lg">
                <span className="font-bold">
                  10.1 استرداد المبالغ المدفوعة للبرامج الملغاة:
                </span>{' '}
                إذا تم إلغاء البرنامج من قبل السنتر أو عدم توفر المقاعد، سيتم
                استرداد المبلغ المدفوع للعميل.
                <br />
                <span className="font-bold"> 10.2 تأكيد التسجيل:</span> يتم
                تأكيد التسجيل في أي دورة أو برنامج بعد الموافقة من السنتر وتوفر
                المقاعد.
                <br />
                <span className="font-bold"> 10.3 شروط الاسترداد:</span> في حالة
                الاسترداد، سيتم خصم 25٪ من المبلغ المدفوع لضريبة القيمة المضافة
                والدفع الإلكتروني. هذا الشرط ساري المفعول إذا تم تقديم طلب
                الاسترداد قبل تاريخ بدء النشاط التدريبي. لن يتم استرداد أي مبالغ
                بعد تاريخ بدء النشاط التدريبي. يمكن تحويل المبلغ إلى محفظة
                المتدرب الداخلية إذا كانوا يرغبون في ذلك.
                <br />
                <span className="font-bold"> خصم للاسترداد:</span> في حالة
                الاسترداد، سيتم خصم 25٪ من المبلغ المدفوع لضريبة القيمة المضافة
                والدفع الإلكتروني.
              </Text>
            </div>

            <div style={{ marginBottom: 30 }}>
              <Text size="xl" weight={700} style={{ marginBottom: 20 }}>
                معلومات الاتصال
              </Text>
              <Text size="lg">
                للتحقيق أو المساعدة، يرجى التواصل معنا من خلال نموذج الاتصال بنا
                على موقعنا الإلكتروني. نرحب بأسئلتكم واهتماماتكم وتعليقاتكم حول
                خدماتنا.
              </Text>
            </div>
          </>
        )}
      </Paper>
    </Container>
  )
}

export default SubscriptionTab
